// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"rivers_wrapper__tMlaW"};